import { render, staticRenderFns } from "./odemeraporu.vue?vue&type=template&id=6b70db56&scoped=true"
import script from "./odemeraporu.vue?vue&type=script&lang=js"
export * from "./odemeraporu.vue?vue&type=script&lang=js"
import style0 from "./odemeraporu.vue?vue&type=style&index=0&id=6b70db56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b70db56",
  null
  
)

export default component.exports